import { __extends } from 'tslib';
import * as React from 'react';
import StepCSSTransitionGroup from '../Animations/StepCSSTransitionGroup.js';
import styles from './Dialog.module.scss.js';

var DialogHeader = (function (_super) {
    __extends(DialogHeader, _super);
    function DialogHeader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DialogHeader.prototype.render = function () {
        var noUnderline = false;
        if (this.props.noUnderline !== undefined &&
            this.props.noUnderline !== null &&
            this.props.noUnderline === true) {
            noUnderline = true;
        }
        return (React.createElement(StepCSSTransitionGroup, { level: 1, className: this.props.className || '' },
            React.createElement("div", { key: "header", className: noUnderline ? styles.headerNoUnderline : styles.header }, this.props.children)));
    };
    return DialogHeader;
}(React.PureComponent));

export { DialogHeader as default };
//# sourceMappingURL=DialogHeader.js.map
